/**
 * Syrian pound.
 */
export var SYP = {
  code: 'SYP',
  base: 10,
  exponent: 2
};